"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateAndTimeFilter = exports.dayOfWeekFilter = exports.dateTimeRangeFilter = void 0;
const __1 = require("../..");
const dateTimeRangeFilter = (periods, param, nationalHolidays) => {
    // 曜日を指定を使用した場合
    if (param.type === 'dayOfWeek') {
        return (0, exports.dayOfWeekFilter)(param, periods, nationalHolidays);
    }
    // 日付を使用を指定した場合
    return (0, exports.dateAndTimeFilter)(param, periods);
};
exports.dateTimeRangeFilter = dateTimeRangeFilter;
// 曜日のフィルター
const dayOfWeekFilter = (param, periods, nationalHolidays) => {
    if (periods.isEmpty()) {
        return periods;
    }
    // これはアクセスしたブラウザのタイムゾーンになる
    let dayOfWeekPeriods = __1.WorkingHoursConverter.convert({
        workingHours: param.hours,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        start: periods.firstPeriod.start,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        end: periods.lastPeriod.end,
        nationalHolidays
    });
    // ブラウザの時刻をページのタイムゾーンに変換する
    dayOfWeekPeriods = dayOfWeekPeriods.convertTZ(param.tz, Intl.DateTimeFormat().resolvedOptions().timeZone);
    return periods.and(dayOfWeekPeriods);
};
exports.dayOfWeekFilter = dayOfWeekFilter;
// 日付のフィルター
const dateAndTimeFilter = (param, periods) => {
    const dateAndTimePeriods = __1.Periods.fromTimeStamp(param.periods);
    return periods.and(dateAndTimePeriods);
};
exports.dateAndTimeFilter = dateAndTimeFilter;
//# sourceMappingURL=dateTimeRangeFilter.js.map